import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import PartnerAddForm from "./PartnerAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const PartnersAdd = () => {
  return (
    <Layout pageTitle="Add Partner">
      <Container>
        <Content>
          <PartnerAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default PartnersAdd;
